import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import React, { Fragment, useContext, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  fetchCheckCodeResetPassword,
  fetchSubmitCodeResetPassword,
} from "../../actions/security";

import CheckIcon from "@mui/icons-material/Check";
import Header from "../../components/Header";
import VerificationCodeInput from "../../components/Reusable/VerificationCodeInput";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const ForgotPasswordCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [state, setState] = useState({ code: "" });
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const [passwordConditions, setPasswordConditions] = useState({
    firstUppercase: false,
    minLength: false,
    number: false,
    specialChar: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showViewPassword, setShowViewPassword] = useState(false);
  const [showViewRePassword, setShowViewRePassword] = useState(false);

  const validatePassword = (password) => {
    const numberRegex = /\d/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    const firstUppercaseRegex = /^[A-Z]/;

    setPasswordConditions({
      firstUppercase: firstUppercaseRegex.test(password),
      minLength: password.length >= 8,
      number: numberRegex.test(password),
      specialChar: specialCharRegex.test(password),
    });
  };

  const onSubmitHandlerNewPassword = (e) => {
    e.preventDefault();
    const { password, confirmPassword } = passwords;

    if (password !== confirmPassword) {
      alert(t("forgotPasswordCode.errors.mismatch"));
      return;
    }

    if (
      !passwordConditions.firstUppercase ||
      !passwordConditions.minLength ||
      !passwordConditions.number ||
      !passwordConditions.specialChar
    ) {
      alert(t("forgotPasswordCode.errors.invalid"));
      return;
    }

    const formState = {
      newPassword: password,
      code: state.code,
    };

    dispatch(fetchSubmitCodeResetPassword(formState, navigate));
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    dispatch(fetchCheckCodeResetPassword(state)).then((res) => {
      setShowPassword(res.success);
    });
  };

  const onChangeHandlerOtp = (value) => {
    setState((prevState) => ({ ...prevState, code: value }));
  };

  const handleTogglePassword = () => {
    setShowViewPassword((prev) => !prev);
  };
  const handleToggleRePassword = () => {
    setShowViewRePassword((prev) => !prev);
  };

  return (
    <Fragment>
      <Header nameClass={"backgorund-color-header"} />
      <div className="login-page-holder reset-password-code-page">
        <div className="login-page-image">
          <div className="login-page-image-title">
            <h1>{t("forgotPasswordCode.title")}</h1>
          </div>
        </div>
        <div className="login-content-form" style={{ padding: "0px 25px" }}>
          <h2>{t("forgotPasswordCode.subtitle")}</h2>
          {showPassword ? (
            <form onSubmit={onSubmitHandlerNewPassword}>
              <Row>
                <Col lg={12} className="mb-3">
                  <TextField
                    fullWidth
                    label={t("forgotPasswordCode.form.newPasswordLabel")}
                    variant="standard"
                    type={showViewPassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleTogglePassword} edge="end">
                            {showViewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    value={passwords.password}
                    onChange={(e) => {
                      setPasswords((prev) => ({
                        ...prev,
                        password: e.target.value,
                      }));
                      validatePassword(e.target.value);
                    }}
                  />
                </Col>
                <Col lg={12} className="mb-3">
                  <TextField
                    fullWidth
                    label={t("forgotPasswordCode.form.confirmPasswordLabel")}
                    variant="standard"
                    type={showViewRePassword ? "text" : "password"}
                    value={passwords.confirmPassword}
                    onChange={(e) =>
                      setPasswords((prev) => ({
                        ...prev,
                        confirmPassword: e.target.value,
                      }))
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleToggleRePassword}
                            edge="end"
                          >
                            {showViewRePassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Col>
                <Col lg={12}>
                  <div className="holder-password-required-items reset-password-conditions">
                    <div className="info-password-required">
                      <div
                        className={`info-password-required-text ${
                          passwordConditions.firstUppercase
                            ? "check-required-success"
                            : ""
                        }`}
                      >
                        <CheckIcon /> {t("registration.info1")}
                      </div>
                      <div
                        className={`info-password-required-text ${
                          passwordConditions.minLength
                            ? "check-required-success"
                            : ""
                        }`}
                      >
                        <CheckIcon /> {t("registration.info2")}
                      </div>
                      <div
                        className={`info-password-required-text ${
                          passwordConditions.number
                            ? "check-required-success"
                            : ""
                        }`}
                      >
                        <CheckIcon /> {t("registration.info3")}
                      </div>
                      <div
                        className={`info-password-required-text ${
                          passwordConditions.specialChar
                            ? "check-required-success"
                            : ""
                        }`}
                      >
                        <CheckIcon /> {t("registration.info4")}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="login-button-item">
                  <Button type="submit">
                    {t("forgotPasswordCode.form.submitPassword")}
                  </Button>
                </Col>
              </Row>
            </form>
          ) : (
            <form onSubmit={onSubmitHandler}>
              <Row>
                <Col lg={12} className="mb-3">
                  <VerificationCodeInput onChange={onChangeHandlerOtp} />
                </Col>
                <Col className="login-button-item">
                  <Button type="submit">
                    {t("forgotPasswordCode.form.submitCode")}
                  </Button>
                </Col>
              </Row>
            </form>
          )}
          <div className="registration-section-login-page d-flex justify-content-between align-items-center">
            <div className="registration-return-button-login">
              <Link to="/login"> {t("login.prijava")}</Link>
            </div>
            <div className="registration-button">
              <Link to="/registration">{t("login.registruj_se")}</Link>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPasswordCode;
